import * as yup from 'yup';

export const metricasSchema = yup.object({
  metricas: yup
    .array()
    .of(
      yup.object({
        descripcion: yup.string().required(),

        cumplido: yup
          .boolean()
          .required('Debe seleccionar una respuesta'),

        observacion: yup.string().when('cumplido', {
          is: false,
          then: schema =>
            schema.required(
              'La observación es obligatoria cuando no se cumple'
            ),
          otherwise: schema => schema.nullable(),
        }),
      })
    )
    .min(1),
});